import { FilterGroups } from '@components/GalleryComponents/GalleryPageContent/GalleryPageContentFiltering';

const prioritizeJoyPrintedThemes = (cards: MarketingData, prioritizationSet: Set<string>): MarketingData => {
  const { joyPrintedThemes, otherThemes } = cards.reduce(
    (acc, curr) => {
      if (prioritizationSet.has(curr.variantThemeId)) {
        acc.joyPrintedThemes.push(curr);
      } else {
        acc.otherThemes.push(curr);
      }
      return acc;
    },
    { joyPrintedThemes: [], otherThemes: [] } as {
      joyPrintedThemes: MarketingData;
      otherThemes: MarketingData;
    }
  );

  return joyPrintedThemes.concat(otherThemes);
};

export const createFilterGroupsProcessor = (productType: GalleryProductType, data: GalleryECardsThemesVariantData) => {
  const joyPrintedThemeIdsSet = new Set(data.stationeryTemplatesByCategory.map(template => template.themeId));
  return (filterGroups: FilterGroups, hasPrints: boolean): FilterGroups => {
    if ((productType !== 'Invitation' && productType !== 'Save the Date') || !hasPrints) {
      return filterGroups;
    }
    /**
     * When viewing save the date or invitation cards, prioritize joy printed themes
     */
    return {
      match: prioritizeJoyPrintedThemes(filterGroups.match, joyPrintedThemeIdsSet),
      noMatch: prioritizeJoyPrintedThemes(filterGroups.noMatch, joyPrintedThemeIdsSet),
    };
  };
};
